import { t } from "i18next";
import { CustomAutocomplete } from "../../Components/custom-combobox/CustomAutocomplete";
import { CustomDisabledTextfield, CustomTextField } from "../../Components/custom-textfield/CustomTextField";
import * as ClaimService from '../../Services/claim-service';
import { CustomHelpText } from "../../Components/custom-help-text/CustomHelpText";
export function ClaimRequestInsuredInfo({ objectDto, setObjectDto, setLoading, validate }) {
    return (
        <div id="personal-info" style={{ display: objectDto.checked > 1 ? "block" : "none" }}>
            <div data-toggle="collapse" data-target="#search-box-2" className="header-box" id="search-box-2-header">
                <h2 className="title-box description-large-customer">{t("claimpersonalinfo").toUpperCase()}</h2>
            </div>
            <div className="border-box-sc row" style={{ display: "block", padding: "0 2.5%" }}>
                <div className="col-md-12 form-group">
                    <fieldset className="insured-information" id="laInfoDiv" >
                        <label className="col-md-12 label-header description-medium-customer">{t("claimpersonalinsured")}</label>
                        <div className="form-group col-md-12">
                            <label className="col-md-2 required description-small-customer">{t("fullname")}</label>
                            <div className="col-md-4">
                                {objectDto.checked === 2 ?
                                    <>
                                        <CustomAutocomplete placeholder={t("messageselectlife")} value={objectDto.laNumber !== undefined ? objectDto.laName || null : null}
                                            data={objectDto.selectionLAList.map((item) => {
                                                return item.laName;
                                            }) || []}
                                            handleChange={(event) => {
                                                if (event.target.textContent !== "") {
                                                    objectDto.selectionLAList.map((item) => {
                                                        if (event.target.textContent === item.laName) {
                                                            objectDto.laNumber = item.laNumber;
                                                            setLoading(true);
                                                            return ClaimService.HandleSelectLifeInsurred(objectDto, setObjectDto, setLoading);
                                                        }
                                                    })
                                                } else {
                                                    setObjectDto({ ...objectDto, laNumber: null, laName: null, laPhone: null, laAddress: null, strLaDob: null, laIdNumber: null });
                                                }
                                            }}
                                        />
                                        <CustomHelpText exist={objectDto.laNumber} hidden={ClaimService.validateValue(objectDto.laNumber) === false && validate === true} />
                                    </>
                                    :
                                    <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.laName || null} />
                                }
                            </div>
                            <label className="col-md-2 description-small-customer">{t("dob")}</label>
                            <div className="col-md-4" style={{ marginBottom: "10px !important" }}>
                                <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.strLaDob || ""} />
                            </div>
                        </div>
                        <div className="col-md-12 form-group">
                            <label className="col-md-2 description-small-customer">{t("idnumber")}</label>
                            <div className="col-md-4">
                                <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.laIdNumber || ""} />
                            </div>
                            <label className="col-md-2 required description-small-customer">{t("phone")}</label>
                            <div className="col-md-4">
                                {
                                    objectDto.checked === 2 && objectDto.laNumber != null ?
                                        <CustomTextField variant="outlined" label={""} size="small" required fullWidth focusColor="#c4960c"
                                            value={objectDto.laPhone || ""} onChange={(e) => { setObjectDto({ ...objectDto, laPhone: e.target.value }) }}
                                            helperText={validate && ClaimService.validateValue(objectDto.laPhone) === false ? t("NotEmptyjavalangString") : ""}
                                        />
                                        :
                                        <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.laPhone || ""} />
                                }
                            </div>
                        </div>
                        <div className="col-md-12 form-group">
                            <label className="col-md-2 required description-small-customer">{t("posaddresscontact")}</label>
                            <div className="col-md-10">
                                {
                                    objectDto.checked === 2 && objectDto.laNumber != null ?
                                        <CustomTextField variant="outlined" label={""} size="small" required fullWidth focusColor="#c4960c"
                                            helperText={validate && ClaimService.validateValue(objectDto.laAddress) === false ? t("NotEmptyjavalangString") : ""}
                                            value={objectDto.laAddress || ""} onChange={(e) => { setObjectDto({ ...objectDto, laAddress: e.target.value }) }}
                                        />
                                        :
                                        <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.laAddress || ""} />
                                }
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    )
}